import { memo, useEffect, useState } from "react";
import { NumberInput } from "react-admin";
import { useWatch, useFormContext } from "react-hook-form";

const BonusQuantityInput = ({ dependOn, saleOrderItemIdSource, ...props }) => {
  const dependValues = useWatch({ name: dependOn });
  const { setValue, getValues } = useFormContext();
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (dependValues) {
      let match = false;
      const saleOrderItemID = getValues(saleOrderItemIdSource);
      for (let i = 0; i < dependValues.length; i++) {
        const elm = dependValues[i];
        if (elm.sale_order_item_id === saleOrderItemID) {
          match = true;
          break;
        }
      }
      if (match && saleOrderItemID) {
        setValue(props.source, "");
        setDisabled(true);
      } else {
        setDisabled(false);
      }
    }
  }, [dependValues, saleOrderItemIdSource]);

  return (
    <NumberInput
      {...props}
      disabled={disabled}
      inputProps={{
        type: "text",
        inputMode: "numeric",
        pattern: "[0-9]*",
      }}
    />
  );
};

const propsAreEqual = (prevProps, nextProps) => {
  if (prevProps.source === nextProps.source) {
    // tidak perlu render ulang
    return true;
  }
  // perlu dirender ulang
  return false;
};

export default memo(BonusQuantityInput, propsAreEqual);
